var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverCaseDes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8467 4.29101C12.5757 4.02008 12.2121 3.87036 11.8343 3.87036H6.72231C5.93805 3.87036 5.29639 4.51203 5.29639 5.29629V16.7037C5.29639 17.488 5.93092 18.1296 6.71518 18.1296H15.2779C16.0621 18.1296 16.7038 17.488 16.7038 16.7037V8.7399C16.7038 8.36203 16.5541 7.99842 16.2831 7.73462L12.8467 4.29101ZM13.139 15.2778H8.8612C8.46907 15.2778 8.14824 14.9569 8.14824 14.5648C8.14824 14.1727 8.46907 13.8518 8.8612 13.8518H13.139C13.5311 13.8518 13.8519 14.1727 13.8519 14.5648C13.8519 14.9569 13.5311 15.2778 13.139 15.2778ZM13.139 12.4259H8.8612C8.46907 12.4259 8.14824 12.1051 8.14824 11.713C8.14824 11.3208 8.46907 11 8.8612 11H13.139C13.5311 11 13.8519 11.3208 13.8519 11.713C13.8519 12.1051 13.5311 12.4259 13.139 12.4259ZM11.7131 8.14814V4.93981L15.6343 8.8611H12.426C12.0339 8.8611 11.7131 8.54027 11.7131 8.14814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverCaseDes);
export default __webpack_public_path__ + "static/media/hoverCaseDes.b7b97a932152f0525a632b0196845e66.svg";
export { ForwardRef as ReactComponent };